import { OfferStatusUpdate } from "./modals/offer-status-update";
import { OfferT } from "../../../domain";
import React from "react";
import { getStatusColor } from "../utils/helpers";
import { useHasPermissions } from "../../../../../public/auth/infrastructure/store/auth-context";
import { useMemo } from "react";
import {
  Button,
  Modal,
  Tooltip,
  useDisclosure,
} from "../../../../../shared/infrastructure";

type StatusFormatProps = {
  data?: OfferT;
  withoutDot?: boolean;
};

export const StatusFormat = ({
  data,
}: StatusFormatProps): React.ReactElement => {
  const { isOpen, open, close } = useDisclosure();
  const hasPermissions = useHasPermissions("update:status-approvals-queue");

  const status = useMemo(() => {
    if (!data) return null;

    const dot = (
      <span
        style={{
          backgroundColor: getStatusColor(data.status ?? ""),
        }}
        className={`h-[10px] w-[10px] rounded-full`}
      />
    );
    const hasStatusComment = data.status_comment && data.status_comment !== "";
    const textColor = getStatusColor(data.status ?? "", "text");

    return (
      <section className="grid grid-flow-col items-center justify-start gap-[8px] pl-[20px] pr-[5px]">
        {data.status !== "pending" && data.status ? dot : null}
        {data.status === "no cap" ? "No cap" : null}
        {data.status === "counter" ? (
          <span className={textColor}>
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0,
            }).format(data.counter_offer ?? 0)}
          </span>
        ) : null}
        {data.status === "pending" || !data.status ? (
          hasPermissions ? (
            <React.Fragment>
              <Button
                className="min-w-auto h-auto w-auto rounded-[5px] px-[10px] py-0 text-[10px]"
                onClick={open}
              >
                Set Status
              </Button>
              <Modal
                open={isOpen}
                onClose={close}
                content={<OfferStatusUpdate data={data} close={close} />}
                classNames={{
                  content:
                    "overflow-hidden p-[20px] min-w-[332px] min-h-[214px]",
                  paper: "rounded-[5px]",
                }}
              />
            </React.Fragment>
          ) : (
            "Pending"
          )
        ) : null}
        {["deleted", "expired"].includes(data.status) && (
          <span className={`${textColor} capitalize`}>{data.status}</span>
        )}
        {data.status !== "pending" && (
          <span className="truncate">
            {hasStatusComment && data.status_comment && (
              <Tooltip text={data.status_comment}>
                {data.status_comment}
              </Tooltip>
            )}
          </span>
        )}
      </section>
    );
  }, [close, data, hasPermissions, isOpen, open]);

  return (
    <section className="grid grid-flow-col items-center justify-start gap-[8px]">
      {status}
    </section>
  );
};
